import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { fetchEvent, setSelectedTicket } from '../../features/event/slice'
import { useInternationalization } from '../../features/i18n'
import ContainerOnMobile from '../../layouts/container-on-mobile'
import { generateSelectedTicket } from '../../utils'
import GuestRow from './components/guest-row'
import PageHeader from './components/page-header'

const DashboardGuestDetail = ({ match }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const status = useSelector(state => state.event.status)
  const eventData = useSelector(state => state.event.data)
  const eventId = match.params.eventId
  const guestId = match.params.id
  const { participant_map } = eventData
  const guestData = participant_map?.[guestId] || {}
  const { language, translate } = useInternationalization()

  const {
    guest_data = []
  } = useSelector(state => state.eventForm.data)
  const guestDataForm = guest_data
  const selectedGuestDataForm = guestDataForm.find(g => g.id === guestId)
  const guestDataArray = selectedGuestDataForm ? selectedGuestDataForm.guests_data : false
  console.log({participant_map})

  const handleSeeTicket = (id) => {
    let cloned, selectedTicket

    if(!id){
      // Generate data for printable ticket detail PDF
      cloned = {...guestData, no: guestData.order_number}
      selectedTicket = generateSelectedTicket(eventData, cloned, language)
    } else {
      cloned = {...participant_map[id], no: participant_map[id].order_number}
      selectedTicket = generateSelectedTicket(eventData, cloned, language)
    }

    dispatch(setSelectedTicket(selectedTicket))
      .then(() => history.push(`/ticket/${eventData.id}/${cloned.no}`))
  }

  useEffect(() => {
    if(
      eventId
      && status === 'idle'
      && match.params
      && match.params.eventId
    ){
      dispatch(fetchEvent(match.params.eventId))
    }
  }, [dispatch, match.params, status, eventId])


  const {
    name,
    occupation = {},
    email,
    phone,
    disability_status = {},
    gender = {},
    order_number
  } = guestData

  return <ContainerOnMobile>
    <PageHeader eventId={eventId}/>
    <hr className="hidden lg:block mt-5 mb-8"/>
    {
      (guestDataArray && guestDataArray.length > 0) ?
      guestDataArray.map((g, index) => <>
        <GuestRow
          key={index}
          guest={{
            order_number: participant_map[g.id].order_number,
            name: participant_map[g.id].name,
            occupation: participant_map[g.id].occupation[language.name] || '-',
            email: participant_map[g.id].email || '-',
            phone: participant_map[g.id].phone || '-',
            disability_status: participant_map[g.id].disability_status[language.name] || '-',
            gender: participant_map[g.id].gender[language.name] || '-',
          }}
          translate={translate}
          onClick={() => handleSeeTicket(g.id)}
        />
        <hr className="mb-8" />
      </>) :
      <GuestRow
        guest={{
          order_number,
          name,
          occupation: occupation[language.name] || '-',
          email: email || '-',
          phone: phone || '-',
          disability_status: disability_status[language.name] || '-',
          gender: gender[language.name] || '-',
        }}
        translate={translate}
        onClick={() => handleSeeTicket(false)}
      />
    }
  </ContainerOnMobile>
}

export { DashboardGuestDetail }
